<template>
    <div class="rounded-lg overflow-hidden mb-4 border border-gray-2">
        <div class="flex py-2 px-4 gap-3.5 bg-white">
            <div class="w-1/3">
                <div v-if="earnpoint.CampaignId" class="campaign-image rounded-md" :style="{'background-image': `url('${getImageUrl(earnpoint.CampaignId)}')`}"></div>
                <div v-else class="bg-white rounded-md">
                    <img class="w-full h-full p-3" src="@/assets/icon/ic-splus.svg" alt="">
                </div>
            </div>
            <div class="w-2/3">
                <div v-if="earnpoint.Detail.indexOf('FortuneWheel') > -1" class="campaign-name text-20 text-blue-1">
                    {{ getMassageFortuneWheel() }}
                </div>
                <div v-else class="campaign-name text-20 text-blue-1">{{earnpoint.Detail}}</div>
                <div class="text-18 text-gray-1">{{getTimeEarn()}}</div>
                <div class="flex justify-end items-center gap-1">
                    <div class="text-26 text-green-1 text-right" >+ {{FilterNumberFormat(getPointMessage())}}</div>
                    <div class="text-20 text-green-1 text-right">{{lbl.history.point}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfigManager from '@/config/ConfigManager';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
export default {
    name: "HistoryEarnItem",
    mixins: [LocaleMixin],
    props: {
        earnpoint: { type: Object, required: true },
    },
    methods: {
        getPointMessage: function () {
            return this.earnpoint.Points;
        },
        getTimeEarn: function () {
            return DatetimeHelper.getDatetimeFullFormatHistoryEarn(this.earnpoint.Timestamp);
        },
        getMassageFortuneWheel: function() {
            let point = JSON.parse(this.earnpoint.Detail)
            point = point[0].Points
            let msg = `ยินดีด้วยค่ะ คุณได้รับ ${point} คะแนน จากเปิดกล่องสุ่มรับของรางวัล`
            return msg
        },
        getImageUrl: function (campaignId) {
            return ConfigManager.getBlobUrl() + "/campaigns/" + campaignId + "-large?time=" + new Date().getTime();
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    @import "@/style/base/image.scss";
    .campaign-name {
        height: 48px;
        @extend %ellipsis-2;
    }
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }

</style>
